import { Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Colors } from 'src/assets/colors/Colors';
import AgGridTable from 'src/components/AgGridTable'
import SelectFormVirtualize from 'src/components/ComponentesFormularios/SelectFormVirtualize';
import { classResponsiveFormDoubleWidth, classResponsiveFormDoubleWidthHeader, classResponsiveFormDoubleWidthHeaderWithoutPaddingX, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED } from 'src/data/ConstantForm';
import { GlobalConstants } from 'src/data/GlobalConstants';
import { alertQuestionService } from 'src/services/alertQuestionService';
import { clientesService } from 'src/services/apiClientes';
import { modalCRUDService } from 'src/services/modalCRUDService';

const columnDef = [
  {headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: false, width: 50},
  {headerName: 'Documento', field: "documento", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Errores', field: "errores", resizable: true, sortable: true, filter: true, width: 50},
  {headerName: 'Detalle', field: "detalle", resizable: true, sortable: true, filter: true, minWidth: 200},
]

const TableExcel = ({properties}) => {

  const { data } = properties 
  const dispatch = useDispatch()
  const tableRef = useRef(null);
  const validoRef = useRef(null);
  const errorRef = useRef(null);
  const [stateButton, setStateButton] = useState(false)
  const [dataRow, setDataRow] = useState([])
  const [dataEstado, setDataEstado] = useState([
    {
      id: 101,
      text: 'Pendiente Aprobación de Liberación'
    },
    {
      id: 103,
      text: 'Aprobada Liberación'
    }
  ])
  const methods = useForm({
    defaultValues:{
      estados: dataEstado[0]
    }
  })
  const { control, getValues, setValue, handleSubmit, formState: { errors } } = methods

  //useEFFECT
  useEffect(() => {
    validoRef.current.innerText =  data.contValidas 
    errorRef.current.innerText = data.contError

    const datos = data.solicitudes.map( item => {
      let detalle = ''
      let flagExtra =  item.extra == undefined ? 0 : item.extra.length

      if(flagExtra > 0){
        item.extra.forEach((el, index) => {
          if(flagExtra == index + 1 ) detalle = detalle + el
          else detalle = `${detalle} ${el} - `
        })
      }

      return (
        {
          fila: item.fila,
          documento: item?.documento,
          errores: flagExtra,
          detalle: detalle
        }
      )
    }
    )

    setDataRow(datos)
}, [])

  //functions

  const onSuccessSubmit = data => {
    alertQuestionService.showAlert({
      title: 'Guardar Solicitudes', question: '¿Estás seguro de guardar las solicitudes?',
      message: ['Ten en cuenta que solo se guardarán ', ' solicitudes debido a que las otras presentan error. Si está de acuerdo dar clic en el botón Aceptar'],
      datos: [properties.data.contValidas],
      actionBtnAceptar: async () => {

        const auxData = []

        properties.data.solicitudes.map( item  => {
          if(item['error'] == undefined){
            let fecha = new Date()
            fecha = fecha.toISOString().slice(0,10)
            item['estado'] = data['estados'].id
            item['dtIngreso'] = fecha
            auxData.push(item)
          } 
        })

        if(auxData.length > 0){
          
          const response = await clientesService.setSolicitudCliente({data: auxData})

          const { status, msg, data } = response

          if(status){
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });
          }else{
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
          }
          
        }else{
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'No se encontrarón solicitudes validas para guardar' } });
        }

        alertQuestionService.clear()
        modalCRUDService.clear()
      },
      actionBtnCancelar: () => alertQuestionService.clear(),
      type: GlobalConstants.alertInfo
    })
    
  } 
  
  const onErrorSubmit = error => { }

  return (
    <FormProvider {...methods}>
      <div className="d-flex justify-content-between align-items-center">
        <div className='d-flex align-items-center justify-content-sm-around w-25'>
          <div>
            <strong style={{fontSize: 20}}>Validos: </strong>
            <span ref={validoRef} style={{fontSize: 20, color: '#64DF38', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong style={{fontSize: 20}}>Errores: </strong>
            <span ref={errorRef} style={{fontSize: 20, color: 'red', fontWeight: 'bold'}}> 0</span>
          </div>
        </div>
        <div className="d-flex justify-content-end pr-5 w-75">
          <SelectFormVirtualize inputProps={{control}} disabled={false} identificador="estados" label="Estado Solicitud" required={true}
                                  className={`${classResponsiveFormDoubleWidthHeaderWithoutPaddingX}`} options={dataEstado}
                                  customError={errors.estados ? ERRORFIELDREQUIRED : null}/>
        </div>
        <div className={`d-flex align-items-center ${stateButton ? 'is-disabled' : ''}`}>
          <Tooltip title="Guardar Solicitudes" aria-label="guardar-solicitudes"> 
              <a className="icon-container-actions d-flex "
                  onClick={handleSubmit(onSuccessSubmit, onErrorSubmit) }>
                  <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                  <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-check fa-2x"/>
              </a>
          </Tooltip>
        </div>
      </div>
      <div >
        <AgGridTable
          referencia={tableRef}
          columnDef={columnDef}
          dataList={dataRow || []}
          rowSelection={'multiple'}
        />
      </div>
    </FormProvider>
  )
}

export default TableExcel